import { getSubscription } from "@/api/sub";
import { executePut } from "@/server/dvaHelper";
import sub, { SubInfo } from "@/types/sub";

export type ISubDetailItem = SubInfo & { followed: boolean };
export interface SubState {
  /** 是否展示组织号关注列表 */
  subListVisible: boolean;

  /** 组织号关注列表 */
  followList: SubInfo[];

  /** 推荐列表 */
  recommendList: SubInfo[];

  /** 当前用户有运营权限的组织号ID */
  authSubIds: string[];

  /** 当前详情 */
  currentSubDetail: ISubDetailItem | null;

  /** 侧边栏展示 */
  modalShow: boolean;
}

export default {
  namespace: "sub",
  state: { subListVisible: false, recommendList: [], followList: [], authSubIds: [] },
  reducers: {
    setSubListVisible(state: SubState, { payload }: { payload: boolean }) {
      return { ...state, subListVisible: payload };
    },
    setAuthSubIds(state: SubState, { payload }: { payload: string[] }) {
      return { ...state, authSubIds: payload };
    },
    setFollowList(state: SubState, { payload }: { payload: SubInfo[] }) {
      return { ...state, followList: payload };
    },
    setRecommendList(state: SubState, { payload }: { payload: SubInfo[] }) {
      return { ...state, recommendList: payload };
    },
    setCurrentSubDetail(state: SubState, { payload }: { payload: SubInfo | null }) {
      return { ...state, currentSubDetail: payload };
    },
    updateCurrentSubDetail(state: SubState, { payload }: { payload: SubInfo | null }) {
      const currentSubDetail = state.currentSubDetail;
      return {
        ...state,
        currentSubDetail: {
          ...currentSubDetail,
          ...payload
        }
      };
    },
    setModalShow(state: SubState, { payload }: { payload: boolean }) {
      return { ...state, modalShow: payload };
    }
  },
  effects: {
    *updateCurrentSubDetailInfo(
      { payload }: { payload: { subId: string; visible: boolean } },
      { call, put, select }: any
    ) {
      const { subId, visible } = payload;
      const subState = yield select(({ sub }: { sub: ISubDetailItem }) => sub);
      const { followList, recommendList } = subState;
      if (subId) {
        const dealFollowList = followList.map((f: SubInfo) => {
          return {
            ...f,
            followed: true
          };
        });
        const dealRecomm = recommendList.map((r: SubInfo) => {
          return {
            ...r,
            followed: false
          };
        });
        const subInfo = [...dealFollowList, ...dealRecomm].find((s) => s.subId === subId);
        if (subInfo) {
          yield executePut(put, "setCurrentSubDetail", subInfo);
        } else {
          const [subDetail, error] = yield getSubscription({ subId }).catch((e) => {
              console.log(`sub detail>>`, e)
          });
          if (subDetail) {
            yield executePut(put, "setCurrentSubDetail", {
              ...subDetail,
              followed: subDetail.isFollowing === 1
            });
          }
        }
      } else {
        yield executePut(put, "setCurrentSubDetail", null);
      }
      yield executePut(put, "setModalShow", visible);
    }
  }
};
